var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14373 18.9718V15.9049C7.14372 15.1278 7.77567 14.4964 8.55843 14.4915H11.4326C12.2189 14.4915 12.8563 15.1243 12.8563 15.9049V18.9629C12.8562 19.637 13.404 20.1848 14.0829 20.1897H16.0438C16.9596 20.192 17.8388 19.8325 18.4872 19.1904C19.1356 18.5483 19.5 17.6765 19.5 16.7672V8.05554C19.5 7.32108 19.1721 6.62441 18.6046 6.1532L11.943 0.863966C10.7785 -0.0611802 9.11537 -0.0312945 7.98539 0.935081L1.46701 6.1532C0.872741 6.61052 0.517552 7.30926 0.5 8.05554V16.7583C0.5 18.6534 2.04738 20.1897 3.95617 20.1897H5.87229C6.19917 20.192 6.51349 20.0648 6.74547 19.8361C6.97746 19.6075 7.10792 19.2963 7.10792 18.9718H7.14373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorHome);
export default __webpack_public_path__ + "static/media/VectorHome.a7af4e46.svg";
export { ForwardRef as ReactComponent };